<template>
    <div>
      <div class="mb-8 flex justify-start max-w-3xl">
        <h1 class="font-bold text-3xl">
          <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('applicationbuy')">Regresar</inertia-link>
          <span class="text-indigo-400 font-medium">/</span>
          Generar Solicitud
        </h1>
       
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
      
          
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="px-4 pt-6 pb-4">Costo</th>
                <th class="px-6 pt-6 pb-4">Cantidad</th>
                <th class="px-6 pt-6 pb-4">Material</th>   
                <th class="px-6 pt-6 pb-4">Precio</th>
                <th class="px-6 pt-6 pb-4">IVA</th>

                <th class="px-6 pt-6 pb-4">Subtotal</th>
                <th class="px-6 pt-6 pb-4" colspan="2">Detalle</th>
              </tr>
              <tr v-for="applicationbuy in applicationsdeatil" :key="applicationbuy.id" class="hover:bg-gray-100 focus-within:bg-gray-100  items-center">
                <td class="border-t px-6 py-4">
                    {{ applicationbuy.cost }}
                </td>
                <td class="border-t px-6 py-4">
                    {{ applicationbuy.amount }}
                </td>
               
                <td class="border-t px-6 py-4">
                    {{ applicationbuy.name }}
                </td>
                <td class="border-t">
                  {{  applicationbuy.cost }}   
                </td>
                <td class="border-t">
                  {{  applicationbuy.iva }}   %
                </td>
                <td class="border-t">
                  {{  applicationbuy.total }}   
                </td>
                
                <td class="border-t">
                  <inertia-link class="px-6 py-4 flex items-center" :href="route('applicationbuy.storeCost', applicationbuy.id)" tabindex="-1">
                    {{ applicationbuy.detail }}
            </inertia-link>
                   
                </td>
                <td class="border-t">
                  <inertia-link class="px-6 py-4 flex items-center" :href="route('applicationbuy.storeCost', applicationbuy.id)" tabindex="-1">
                   <button class="btn-indigo">Editar</button>
            </inertia-link>
                   
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="px-6 pt-6 pb-4">SUBTOTAL 0%</td>
                <td class="px-6 pt-6 pb-4">{{ application.subtotal_cero }}</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="px-6 pt-6 pb-4">SUBTOTAL 5%</td>
                <td class="px-6 pt-6 pb-4">{{ application.subtotal_cinco }}</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="px-6 pt-6 pb-4">SUBTOTAL 12%-15%</td>
                <td class="px-6 pt-6 pb-4">{{ application.subtotal }}</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="px-6 pt-6 pb-4">IVA 0%</td>
                <td class="px-6 pt-6 pb-4">{{ application.iva_cero }}</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="px-6 pt-6 pb-4">IVA 5%</td>
                <td class="px-6 pt-6 pb-4">{{ application.iva_cinco }}</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="px-6 pt-6 pb-4">IVA 12%-15%</td>
                <td class="px-6 pt-6 pb-4">{{ application.iva }}</td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="px-6 pt-6 pb-4"><b>Total</b></td>
                <td class="px-6 pt-6 pb-4">{{ application.total_general }}</td>
                <td></td>
              </tr>
            </table>
           
      <pagination class="mt-6" :links="applicationsdeatil.links" />
  </div> 
    </div>
    
  </template>
  
  <script>
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/LayoutMenu'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import Pagination from '@/Shared/Pagination'
  import SearchFilter from '@/Shared/SearchFilter'
  import LoadingButton from '@/Shared/LoadingButton'
  
  export default {
    metaInfo: { title: 'ApplicationsBuy' },
    components: {
      Icon,
      Pagination,
      SearchFilter,
      LoadingButton,
    },
    layout: Layout,
    props: {
      filters: Object,
      applicationsdeatil: Array,
      application: Object,
    },
    data() {
      return {
            
      }
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function() {
          this.$inertia.get(this.route('applicationbuy.createPagos'), pickBy(this.form), { preserveState: true })
        }, 150),
      },
    },
    methods: {
    },
  }
  </script>
  